import React, { useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import PublicRoutes from './publicRoutes';
import PrivateRoutes from './privateRoutes';
import { TokenContext } from '../service/context/tokencontent';

const RootRoutes = () => {
  const { token } = useContext(TokenContext)!;
  // console.log(token,"routes")
  return (
    <BrowserRouter>
      {token ? <PrivateRoutes /> : <PublicRoutes />}
    </BrowserRouter>
  );
};

export default RootRoutes;
